import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { BASE_URL } from "utils/constant";
import { useAlert } from "components/UI_components/Alert";

const MaterialEditDeleteSection = ({ item, onBack, userPermissions, onMaterialUpdated }) => {
  const alert = useAlert();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDeleteMaterial = async () => {
    if (!userPermissions?.edit_material_management && !userPermissions?.edit_all && !userPermissions?.is_admin) {
      alert.addAlert("You don't have permission to delete material", "error");
      return;
    }

    if (window.confirm("Are you sure you want to delete this material? This action cannot be undone.")) {
      try {
        setIsSubmitting(true);
        const accessToken = localStorage.getItem("access");
        const response = await fetch(
          `${BASE_URL}/inventory/delete-material/${item.id}/`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${accessToken.trim()}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete material");
        }

        alert.addAlert("Material deleted successfully", "success");
        onBack(); // Navigate back to the materials list
      } catch (error) {
        console.error("Error deleting material:", error);
        alert.addAlert(`Error deleting material: ${error.message}`, "error");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <div className="flex items-center gap-2 mt-4">
        <button
          onClick={handleDeleteMaterial}
          className="flex items-center gap-1 text-red-600 hover:text-red-800 px-3 py-1 border border-red-200 rounded-md hover:bg-red-50"
          title="Delete material"
          disabled={isSubmitting}
        >
          <Trash2 className="w-4 h-4" />
          <span>Delete</span>
        </button>
      </div>
    </>
  );
};

export default MaterialEditDeleteSection;